module.exports = __webpack_public_path__ + "static/img/3.03aa4dcb.png";